import axios from '@/utils/request'
var Qs = require('qs')
export default {
	// 2021-01-27
	findOwnerStore() {
		return axios.get('/adapterAmazon/amazon-stores/find-owner-store');
	},
	// 2021-01-27
	batchManualAckOrder(params) {
		return axios.get('/adapterAmazon/amazon-stores/batch-manual-ack-order?' + Qs.stringify(params, { arrayFormat: 'repeat' }));
	},
	// 2021-01-27
	findByTenantId() {
		return axios.get('/adapterAmazon/amazon-stores/find-by-tenant-id');
	},
	// 2021-01-27
	create(params) {
		return axios.post('/adapterAmazon/amazon-stores', params);
	},
	// 2021-01-27
	delete(id) {
		return axios.delete('/adapterAmazon/amazon-stores/' + id);
	},
	// 2021-01-27
	update(id, params) {
		return axios.put('/adapterAmazon/amazon-stores/' + id, params);
	},
	// 2021-03-27
	getOauthUri(id) {
		return axios.get('/adapterAmazon/amazon-stores/' + id + '/get-oauth-uri');
	},
	// 2021-03-27
	accessToken(id, params) {
		return axios.put('/adapterAmazon/amazon-stores/' + id + '/access-token', params);
	},
	// 2021-03-27
	subscribe(id) {
		return axios.put('/adapterAmazon/amazon-stores/' + id + '/subscribe');
	},
	// 2021-04-05
	manualAuth(id, params) {
		return axios.put('/adapterAmazon/amazon-stores/' + id + '/manual-auth', params);
	},

	// 2021-03-27
	clearSubscribe(id) {
		return axios.put('/adapterAmazon/amazon-stores/' + id + '/clear-subscribe');
	},

	// 2022-06-15
	updateNoticeUrl(id, params) {
		return axios.put('/adapterAmazon/amazon-stores/' + id + '/update-notice-url', params);
	},
}
